"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInitDependencies = exports.initDependenciesFactory = exports.dependencies = void 0;
var features_1 = require("../features");
Object.defineProperty(exports, "dependencies", { enumerable: true, get: function () { return features_1.dependencies; } });
var features_2 = require("../features");
Object.defineProperty(exports, "initDependenciesFactory", { enumerable: true, get: function () { return features_2.initDependenciesFactory; } });
Object.defineProperty(exports, "getInitDependencies", { enumerable: true, get: function () { return features_2.getInitDependencies; } });
//# sourceMappingURL=index.js.map